import app, { vuwer } from "@@assets/scripts/common";
import { formImporter } from "@@assets/form";
import formProps from "./_formProps";

const promise = formImporter();

vuwer.add("contactSection", {
	selector: "#contact_section",
	async onReadyFirst($self) {
		if(!$self) {
			return false;
		}
		
		await promise;
		
		this.add("fm", {
			...formProps,
			app,
			selector: "#contact_form",
			ACTION_URL: `${app.config.apipath}/contacts`,
		});
		
		// appから直接アクセス可能にする
		app.fm = this.get("fm");
		
		if(app.device[0] === "sp") {
			vuwer.$window.on("beforeunload", e => {
				if(app.fm.getActiveSheet().name !== "finish") {
					return "このサイトを離れますか？（入力したデータは保存されません）";
				}
			});
		}
	}
});
